import React from 'react';

const Textarea = ({ id, name, placeholder, required, onChange, className = '' }) => {
    return (
        <textarea id={id} name={name} placeholder={placeholder ?? ''} required={required} rows={5} onInput={onChange ? (e) => onChange(e) : () => { }} className={className} />
    );
}

export default Textarea;